import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowComponent
    ? _c(
        "div",
        [
          _c("AppointmentCalendarSkeleton", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            staticClass: "px-2",
            attrs: { "is-collapsed": _vm.isCollapsed },
          }),
          _vm._v(" "),
          _c(
            "AppointmentDataCard",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isLoading,
                  expression: "!isLoading",
                },
              ],
              ref: "appointment-calendar",
              staticClass: "px-2 overflow-visible",
              attrs: {
                "data-qa": "appointment_calendar",
                "qa-locator": "appointment_data_card",
                "prepend-icon": "ui-icon-calendar-date-and-clock",
                "card-class": "py-2",
                "min-height": "56",
                name: _vm.calendarTitle,
                subtitle: _vm.durationServiceText,
                "is-error-state": _vm.isErrorState,
                "has-primary-border": _vm.hasPrimaryBorder,
                "error-description": _vm.errorDescription,
              },
              scopedSlots: _vm._u(
                [
                  _vm.isCollapsed &&
                  !_vm.editableCalendar.selectedDate.isSlotFixed
                    ? {
                        key: "icon",
                        fn: function () {
                          return [
                            _c("div", {
                              staticClass: "ui-icon-pen",
                              style: { cursor: "pointer" },
                              attrs: {
                                "data-qa":
                                  "appointment_calendar_click_listener",
                              },
                              on: { click: _vm.handleClickOpenSchedule },
                            }),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _vm.isShowNearestAvailableBanner
                ? _c(
                    "BaseAlert",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        color: "text-error",
                        "data-qa": "appointment_calendar_warning",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "Клиника не работает в это время.",
                              _vm.options
                            )
                          )
                      ),
                      _c("br"),
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("Ближайшее время для записи:", _vm.options)
                          ) +
                          " " +
                          _vm._s(_vm.nearestAvailableDate) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowCardAppointment
                ? _c(
                    VCard,
                    {
                      attrs: {
                        "max-width": "initial",
                        color: "",
                        elevation: 0,
                      },
                    },
                    [
                      !_vm.isEmptyCalendarList
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "pb-2",
                                class: {
                                  "mx-n2":
                                    (_vm.isMobile &&
                                      (_vm.hasPrimaryBorder ||
                                        _vm.isErrorState)) ||
                                    !_vm.isMobile,
                                  "mx-n4":
                                    _vm.isMobile &&
                                    !(_vm.hasPrimaryBorder || _vm.isErrorState),
                                },
                              },
                              [
                                !_vm.isLoading
                                  ? _c("AppointmentCalendar", {
                                      attrs: {
                                        "data-qa":
                                          "appointment_calendar_component",
                                        "padding-x": _vm.isMobile
                                          ? _vm.hasPrimaryBorder ||
                                            _vm.isErrorState
                                            ? 8
                                            : 16
                                          : 8,
                                        slots:
                                          _vm.editableCalendar.calendarList,
                                        "init-day": _vm.initSlot.day,
                                        fog:
                                          !_vm.isMobile &&
                                          !(
                                            _vm.hasPrimaryBorder ||
                                            _vm.isErrorState
                                          ),
                                      },
                                      on: {
                                        "calendar:time-choice":
                                          _vm.handleCalendarTimeChoice,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowDoctorRedirectButton
                        ? _c(
                            VBtn,
                            {
                              class: {
                                "mb-4": _vm.isMobile,
                              },
                              attrs: {
                                block: _vm.isMobile,
                                width: _vm.isMobile ? "" : "389px",
                                elevation: 0,
                                color: "primary",
                              },
                              on: { click: _vm.handleClickRedirectDoctor },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t("На страницу врача", _vm.options)
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }